import { CONSTANTS } from '@/constants';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export const KEY_AUTH = '@app/egg-vault/address';

interface AuthStore {
  address: string;
  username: string;
  profile_picture_url?: string | undefined;
  isLoading: boolean;
}

type Actions = {
  setAddress: (address: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  setUserInfo: (info: { address: string; username: string; profile_picture_url?: string }) => void;
};

export const useAuth = create<AuthStore & Actions>()(
  immer((set) => ({
    address: localStorage.getItem(KEY_AUTH) || '',
    username: '',
    profile_picture_url: CONSTANTS.DEFAULT_AVATAR,
    isLoading: false,
    setIsLoading: (isLoading) =>
      set((state) => {
        state.isLoading = isLoading;
      }),
    setAddress: (address) =>
      set((state) => {
        state.address = address;
      }),

    setUserInfo: (info) => {
      set({ ...info });
    },
  })),
);

export interface UserResponse {
  username: string;
  address: string;
  profile_picture_url: null;
}
